import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { load } from "@cashfreepayments/cashfree-js";
import { toast } from "react-toastify";
export default function HostedCheckout() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("session_id");

  useEffect(() => {
    if (sessionId) {
      var initializeSDK = async function () {
        let cashfree = await load({
          mode: process.env.REACT_APP_CASHFREE_MODE,
        });
        cashfree
          .subscriptionsCheckout({
            subsSessionId: sessionId,
            redirectTarget: "",
          })
          .then(function (result: any) {
            if (result.error) {
              toast.error(result.error.message);
            }
          });
      };

      initializeSDK();
    }
  }, [sessionId]);
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col items-center justify-center w-[95%]">
        <div className="flex space-x-2 justify-center items-center">
          <span className="sr-only">Loading...</span>
          <div className="h-4 w-4 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-4 w-4 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-4 w-4 bg-indigo-500 rounded-full animate-bounce"></div>
        </div>
        <h1 className="text-2xl  mb-3 font-semibold mt-2 text-center">
          Redirecting to Payment Page...
        </h1>
        <p className="text-sm text-gray-600 w-full flex flex-wrap justify-center">
          Please wait while we redirect you to the payment page.
        </p>
      </div>
    </div>
  );
}
